import React, { useState, useEffect } from 'react';
import './activo.css';
import { useForm } from '../../hooks/useForm';
import { useAxiosPost } from '../../hooks/useSuscribir';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Activo = (props) => {

    const [t, i18n] = useTranslation("global");
    const [t2] = useTranslation("detail_blog");
    const [formSubmitted, setFormSubmitted] = useState(false);
    const { formState, onInputChange, name, lastName, email, onResetForm } = useForm({
        fromName: '',
        body: '',
    });

    const handleFormSubmitted = (value) => {
        setFormSubmitted(value);
    };

    const { data, isLoading, error } = useAxiosPost(
        formSubmitted
            ? 'https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/subscriber/create'
            : null,
        {
            name: props.nombre,
            lastName: props.apellido,
            email: props.correo
        },
        handleFormSubmitted
    );

    const onFormSubmit = (event) => {
        event.preventDefault();
        if (props.nombre.length <= 1) {
            alert((t2('comments.v_nombre')));
            return;
        }
        if (props.correo <= 1) {
            alert((t2('comments.v_email')));
            return;
        }
        if (props.valid) {

        }
        else {
            alert((t2('comments.v_valido')));
            return;
        }
        console.log("va a guardar?");
        setFormSubmitted(true);

    }

    useEffect(() => {

        if (!isLoading && formSubmitted) {
    
            console.log("Guardado correctamente");
    
            props.onSuccess();
            onResetForm();
            setFormSubmitted(false);
    
        }
    
    }, [isLoading]);

    return (
        <div>

            <form onSubmit={onFormSubmit}>
                <div class="contenedor_Comentario2 ">
                    {
                        isLoading ?
                            (<span>{(t('forms.sending'))}</span>) :
                            (<button
                                className='btnSuscri subscribe-modal__submit typo-book-title'
                                type='submit'
                            >
                                {(t('general.suscribirse'))}
                            </button>)
                    }
                </div>
            </form>
        </div>
    );
};
export default Activo;